import { Typography } from 'antd';
import type { ReactNode } from 'react';

type OrgSectionHeaderProps = {
  title: string;
  description?: string;
};

export function OrgSectionHeader({ title, description }: OrgSectionHeaderProps) {
  return (
    <div style={{ marginBottom: 14 }}>
      <Typography.Title level={4} style={{ margin: 0, fontSize: 18, lineHeight: 1.3 }}>
        {title}
      </Typography.Title>
      {description ? (
        <Typography.Text style={{ display: 'block', marginTop: 6, color: '#667085', fontSize: 15, lineHeight: 1.5 }}>
          {description}
        </Typography.Text>
      ) : null}
    </div>
  );
}
